import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslationService } from '../../services/translation-service/translation.service';
import { Router } from '@angular/router';
import { ROUTES } from '../../../app.routes';
import { ExternalLinkService } from '../../services/external-link/external-link.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-header',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
    contactLink: string;
    private langSubscription!: Subscription;
    
    constructor(private translationService: TranslationService, private router: Router, private linkService: ExternalLinkService, private translate: TranslateService) { 
        this.contactLink = linkService.getLink('CONTACT_US');
    }

    ngOnInit(): void {
        this.langSubscription = this.translate.onLangChange.subscribe(() => {
            this.contactLink = this.linkService.getLink('CONTACT_US');
        });
    }

    ngOnDestroy(): void {
        if (this.langSubscription) {
            this.langSubscription.unsubscribe();
        }
    }

    /**
     * Toggle between English and Spanish languages
     */
    toggleLanguage(): void {
        const newLang = this.translationService.getOppositeLanguage();
        this.translationService.switchLang(newLang);
    }

    onHeader(): void {
        this.router.navigate([ROUTES.LOGIN]);
    }
}
